import {useSelector} from "react-redux";

export default function () {
    const dataSourceHandles = useSelector(state => state.dataSourceHandles.dataSourceHandles);
    const loadingDataSourceHandles = useSelector(state => state.dataSourceHandles.loading);
    return { dataSourceHandles, loadingDataSourceHandles };
}